import React from 'react';
import { Link } from 'carbon-components-react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { fetchResetLodgeEnquiry } from 'redux/enquiries';
import { APP_URL } from 'types';
import { Network } from '@carbon/pictograms-react';

export const NoRowData: React.FC<{}> = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const anotherEnquiryHandler = async () => {
    dispatch(fetchResetLodgeEnquiry());
    setTimeout(() => {
      history.push(`${APP_URL.LODGE_NEW_ENQUIRY}`);
    }, 200);
  };

  return (
    <div className="enquiries-no-data--wrapper">
      <Network />
      <h2 className="enquiries-no-data--body-text">
        There is no data to display or the data could not be loaded
      </h2>
      <p>
        <Link onClick={anotherEnquiryHandler} href="#">
          Lodge a new enquiry
        </Link>
      </p>
    </div>
  );
};

export default NoRowData;
